import mietminderung from '../../fields/cases/mietminderung';

export const MUTATION_UPDATE_MM_CASE = /* GraphQL */ `
	mutation($input: MietminderungCaseUpdate!, $id: String!) {
		updateMietminderungCase(input: $input, id: $id) {
			${mietminderung}
		}
	}
`;
